(function () {
  if (!window.matchMedia('(min-width: 990px)').matches) return;
  document.querySelectorAll('.header__inline-menu details').forEach(function (details) {
    var closeTimer;
    details.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      details.setAttribute('open', '');
    });
    details.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(function () {
        details.removeAttribute('open');
      }, 180);
    });
  });
})();
